"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Generated API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserApi = exports.UserApiFactory = exports.UserApiFp = exports.UserApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * UserApi - axios parameter creator
 * @export
 */
const UserApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} token
         * @param {string} [redirect]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointActivateEmail: (token_1, redirect_1, ...args_1) => __awaiter(this, [token_1, redirect_1, ...args_1], void 0, function* (token, redirect, options = {}) {
            // verify required parameter 'token' is not null or undefined
            (0, common_1.assertParamExists)('userEndpointActivateEmail', 'token', token);
            const localVarPath = `/users/activateEmail/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (redirect !== undefined) {
                localVarQueryParameter['redirect'] = redirect;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} body New email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointChangeEmail: (body_1, ...args_2) => __awaiter(this, [body_1, ...args_2], void 0, function* (body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('userEndpointChangeEmail', 'body', body);
            const localVarPath = `/users/changeEmail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ChangePasswordDTO} changePasswordDTO Change password info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointChangePassword: (changePasswordDTO_1, ...args_3) => __awaiter(this, [changePasswordDTO_1, ...args_3], void 0, function* (changePasswordDTO, options = {}) {
            // verify required parameter 'changePasswordDTO' is not null or undefined
            (0, common_1.assertParamExists)('userEndpointChangePassword', 'changePasswordDTO', changePasswordDTO);
            const localVarPath = `/users/changePassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(changePasswordDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointCheckAuth: (...args_4) => __awaiter(this, [...args_4], void 0, function* (options = {}) {
            const localVarPath = `/users/auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {InitialSetupRequest} [initialSetupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointDoInitialSetup: (initialSetupRequest_1, ...args_5) => __awaiter(this, [initialSetupRequest_1, ...args_5], void 0, function* (initialSetupRequest, options = {}) {
            const localVarPath = `/users/initialSetup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(initialSetupRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} body email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointDoesEmailExist: (body_2, ...args_6) => __awaiter(this, [body_2, ...args_6], void 0, function* (body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('userEndpointDoesEmailExist', 'body', body);
            const localVarPath = `/users/emailExists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} body googleToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointDoesGoogleUserExist: (body_3, ...args_7) => __awaiter(this, [body_3, ...args_7], void 0, function* (body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('userEndpointDoesGoogleUserExist', 'body', body);
            const localVarPath = `/users/nameExistsGoogle`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} body username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointDoesUsernameExist: (body_4, ...args_8) => __awaiter(this, [body_4, ...args_8], void 0, function* (body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('userEndpointDoesUsernameExist', 'body', body);
            const localVarPath = `/users/nameExists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {boolean} [createUsers]
         * @param {string} [xKeycloakUserlessToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointGetCurrentKeycloakUsers: (createUsers_1, xKeycloakUserlessToken_1, ...args_9) => __awaiter(this, [createUsers_1, xKeycloakUserlessToken_1, ...args_9], void 0, function* (createUsers, xKeycloakUserlessToken, options = {}) {
            const localVarPath = `/users/keycloakUsers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (createUsers !== undefined) {
                localVarQueryParameter['createUsers'] = createUsers;
            }
            if (xKeycloakUserlessToken != null) {
                localVarHeaderParameter['x-keycloak-userless-token'] = String(xKeycloakUserlessToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointGetExternalUsers: (userId_1, ...args_10) => __awaiter(this, [userId_1, ...args_10], void 0, function* (userId, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('userEndpointGetExternalUsers', 'userId', userId);
            const localVarPath = `/users/externalUsers/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [companyReference]
         * @param {string} [from]
         * @param {string} [jobTitle]
         * @param {string} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointGetSessionStats: (companyReference_1, from_1, jobTitle_1, to_1, ...args_11) => __awaiter(this, [companyReference_1, from_1, jobTitle_1, to_1, ...args_11], void 0, function* (companyReference, from, jobTitle, to, options = {}) {
            const localVarPath = `/users/stats/sessions-range`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (companyReference !== undefined) {
                localVarQueryParameter['companyReference'] = companyReference;
            }
            if (from !== undefined) {
                localVarQueryParameter['from'] = (from instanceof Date) ?
                    from.toISOString() :
                    from;
            }
            if (jobTitle !== undefined) {
                localVarQueryParameter['jobTitle'] = jobTitle;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = (to instanceof Date) ?
                    to.toISOString() :
                    to;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [from]
         * @param {string} [to]
         * @param {string} [username]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointGetSessionStatsExtUser: (from_2, to_2, username_1, ...args_12) => __awaiter(this, [from_2, to_2, username_1, ...args_12], void 0, function* (from, to, username, options = {}) {
            const localVarPath = `/users/stats/sessions-by-ext-user-range`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (from !== undefined) {
                localVarQueryParameter['from'] = (from instanceof Date) ?
                    from.toISOString() :
                    from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = (to instanceof Date) ?
                    to.toISOString() :
                    to;
            }
            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [from]
         * @param {string} [to]
         * @param {string} [username]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointGetSessionStatsUser: (from_3, to_3, username_2, ...args_13) => __awaiter(this, [from_3, to_3, username_2, ...args_13], void 0, function* (from, to, username, options = {}) {
            const localVarPath = `/users/stats/sessions-by-user-range`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (from !== undefined) {
                localVarQueryParameter['from'] = (from instanceof Date) ?
                    from.toISOString() :
                    from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = (to instanceof Date) ?
                    to.toISOString() :
                    to;
            }
            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointGetUserInfo: (username_3, ...args_14) => __awaiter(this, [username_3, ...args_14], void 0, function* (username, options = {}) {
            // verify required parameter 'username' is not null or undefined
            (0, common_1.assertParamExists)('userEndpointGetUserInfo', 'username', username);
            const localVarPath = `/users/{username}/info`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [hasPermission]
         * @param {string} [hasRole]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointGetUsers: (hasPermission_1, hasRole_1, ...args_15) => __awaiter(this, [hasPermission_1, hasRole_1, ...args_15], void 0, function* (hasPermission, hasRole, options = {}) {
            const localVarPath = `/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (hasPermission !== undefined) {
                localVarQueryParameter['hasPermission'] = hasPermission;
            }
            if (hasRole !== undefined) {
                localVarQueryParameter['hasRole'] = hasRole;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<string>} [permission]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointIsPermitted: (permission_1, ...args_16) => __awaiter(this, [permission_1, ...args_16], void 0, function* (permission, options = {}) {
            const localVarPath = `/users/isPermitted`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (permission) {
                localVarQueryParameter['permission'] = permission;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {object} body google token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointLoginGoogle: (body_5, ...args_17) => __awaiter(this, [body_5, ...args_17], void 0, function* (body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('userEndpointLoginGoogle', 'body', body);
            const localVarPath = `/users/loginGoogle`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {object} body creationInfo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointRegisterUser: (body_6, ...args_18) => __awaiter(this, [body_6, ...args_18], void 0, function* (body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('userEndpointRegisterUser', 'body', body);
            const localVarPath = `/users/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} body google token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointRegisterUserGoogle: (body_7, ...args_19) => __awaiter(this, [body_7, ...args_19], void 0, function* (body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('userEndpointRegisterUserGoogle', 'body', body);
            const localVarPath = `/users/registerGoogle`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} body username
         * @param {string} [from]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointRequestResetPassword: (body_8, from_4, ...args_20) => __awaiter(this, [body_8, from_4, ...args_20], void 0, function* (body, from, options = {}) {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('userEndpointRequestResetPassword', 'body', body);
            const localVarPath = `/users/requestResetPassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ResetPasswordWithTokenDTO} resetPasswordWithTokenDTO Reset password info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointResetPassword: (resetPasswordWithTokenDTO_1, ...args_21) => __awaiter(this, [resetPasswordWithTokenDTO_1, ...args_21], void 0, function* (resetPasswordWithTokenDTO, options = {}) {
            // verify required parameter 'resetPasswordWithTokenDTO' is not null or undefined
            (0, common_1.assertParamExists)('userEndpointResetPassword', 'resetPasswordWithTokenDTO', resetPasswordWithTokenDTO);
            const localVarPath = `/users/resetPassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(resetPasswordWithTokenDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointRolesAndPermissions: (...args_22) => __awaiter(this, [...args_22], void 0, function* (options = {}) {
            const localVarPath = `/users/permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointUserInfo: (...args_23) => __awaiter(this, [...args_23], void 0, function* (options = {}) {
            const localVarPath = `/users/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [from]
         * @param {number} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointUserStatistics: (from_5, to_4, ...args_24) => __awaiter(this, [from_5, to_4, ...args_24], void 0, function* (from, to, options = {}) {
            const localVarPath = `/users/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.UserApiAxiosParamCreator = UserApiAxiosParamCreator;
/**
 * UserApi - functional programming interface
 * @export
 */
const UserApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.UserApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} token
         * @param {string} [redirect]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointActivateEmail(token, redirect, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userEndpointActivateEmail(token, redirect, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UserApi.userEndpointActivateEmail']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} body New email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointChangeEmail(body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userEndpointChangeEmail(body, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UserApi.userEndpointChangeEmail']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {ChangePasswordDTO} changePasswordDTO Change password info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointChangePassword(changePasswordDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userEndpointChangePassword(changePasswordDTO, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UserApi.userEndpointChangePassword']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointCheckAuth(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userEndpointCheckAuth(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UserApi.userEndpointCheckAuth']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {InitialSetupRequest} [initialSetupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointDoInitialSetup(initialSetupRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userEndpointDoInitialSetup(initialSetupRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UserApi.userEndpointDoInitialSetup']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} body email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointDoesEmailExist(body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userEndpointDoesEmailExist(body, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UserApi.userEndpointDoesEmailExist']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} body googleToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointDoesGoogleUserExist(body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userEndpointDoesGoogleUserExist(body, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UserApi.userEndpointDoesGoogleUserExist']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} body username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointDoesUsernameExist(body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userEndpointDoesUsernameExist(body, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UserApi.userEndpointDoesUsernameExist']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {boolean} [createUsers]
         * @param {string} [xKeycloakUserlessToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointGetCurrentKeycloakUsers(createUsers, xKeycloakUserlessToken, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userEndpointGetCurrentKeycloakUsers(createUsers, xKeycloakUserlessToken, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UserApi.userEndpointGetCurrentKeycloakUsers']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointGetExternalUsers(userId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userEndpointGetExternalUsers(userId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UserApi.userEndpointGetExternalUsers']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [companyReference]
         * @param {string} [from]
         * @param {string} [jobTitle]
         * @param {string} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointGetSessionStats(companyReference, from, jobTitle, to, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userEndpointGetSessionStats(companyReference, from, jobTitle, to, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UserApi.userEndpointGetSessionStats']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [from]
         * @param {string} [to]
         * @param {string} [username]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointGetSessionStatsExtUser(from, to, username, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userEndpointGetSessionStatsExtUser(from, to, username, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UserApi.userEndpointGetSessionStatsExtUser']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [from]
         * @param {string} [to]
         * @param {string} [username]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointGetSessionStatsUser(from, to, username, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userEndpointGetSessionStatsUser(from, to, username, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UserApi.userEndpointGetSessionStatsUser']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointGetUserInfo(username, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userEndpointGetUserInfo(username, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UserApi.userEndpointGetUserInfo']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [hasPermission]
         * @param {string} [hasRole]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointGetUsers(hasPermission, hasRole, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userEndpointGetUsers(hasPermission, hasRole, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UserApi.userEndpointGetUsers']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<string>} [permission]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointIsPermitted(permission, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userEndpointIsPermitted(permission, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UserApi.userEndpointIsPermitted']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {object} body google token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointLoginGoogle(body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userEndpointLoginGoogle(body, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UserApi.userEndpointLoginGoogle']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {object} body creationInfo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointRegisterUser(body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userEndpointRegisterUser(body, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UserApi.userEndpointRegisterUser']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} body google token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointRegisterUserGoogle(body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userEndpointRegisterUserGoogle(body, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UserApi.userEndpointRegisterUserGoogle']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} body username
         * @param {string} [from]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointRequestResetPassword(body, from, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userEndpointRequestResetPassword(body, from, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UserApi.userEndpointRequestResetPassword']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {ResetPasswordWithTokenDTO} resetPasswordWithTokenDTO Reset password info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointResetPassword(resetPasswordWithTokenDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userEndpointResetPassword(resetPasswordWithTokenDTO, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UserApi.userEndpointResetPassword']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointRolesAndPermissions(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userEndpointRolesAndPermissions(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UserApi.userEndpointRolesAndPermissions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointUserInfo(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userEndpointUserInfo(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UserApi.userEndpointUserInfo']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [from]
         * @param {number} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointUserStatistics(from, to, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userEndpointUserStatistics(from, to, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UserApi.userEndpointUserStatistics']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.UserApiFp = UserApiFp;
/**
 * UserApi - factory interface
 * @export
 */
const UserApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.UserApiFp)(configuration);
    return {
        /**
         *
         * @param {UserApiUserEndpointActivateEmailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointActivateEmail(requestParameters, options) {
            return localVarFp.userEndpointActivateEmail(requestParameters.token, requestParameters.redirect, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UserApiUserEndpointChangeEmailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointChangeEmail(requestParameters, options) {
            return localVarFp.userEndpointChangeEmail(requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UserApiUserEndpointChangePasswordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointChangePassword(requestParameters, options) {
            return localVarFp.userEndpointChangePassword(requestParameters.changePasswordDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointCheckAuth(options) {
            return localVarFp.userEndpointCheckAuth(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UserApiUserEndpointDoInitialSetupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointDoInitialSetup(requestParameters = {}, options) {
            return localVarFp.userEndpointDoInitialSetup(requestParameters.initialSetupRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UserApiUserEndpointDoesEmailExistRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointDoesEmailExist(requestParameters, options) {
            return localVarFp.userEndpointDoesEmailExist(requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UserApiUserEndpointDoesGoogleUserExistRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointDoesGoogleUserExist(requestParameters, options) {
            return localVarFp.userEndpointDoesGoogleUserExist(requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UserApiUserEndpointDoesUsernameExistRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointDoesUsernameExist(requestParameters, options) {
            return localVarFp.userEndpointDoesUsernameExist(requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UserApiUserEndpointGetCurrentKeycloakUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointGetCurrentKeycloakUsers(requestParameters = {}, options) {
            return localVarFp.userEndpointGetCurrentKeycloakUsers(requestParameters.createUsers, requestParameters.xKeycloakUserlessToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UserApiUserEndpointGetExternalUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointGetExternalUsers(requestParameters, options) {
            return localVarFp.userEndpointGetExternalUsers(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UserApiUserEndpointGetSessionStatsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointGetSessionStats(requestParameters = {}, options) {
            return localVarFp.userEndpointGetSessionStats(requestParameters.companyReference, requestParameters.from, requestParameters.jobTitle, requestParameters.to, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UserApiUserEndpointGetSessionStatsExtUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointGetSessionStatsExtUser(requestParameters = {}, options) {
            return localVarFp.userEndpointGetSessionStatsExtUser(requestParameters.from, requestParameters.to, requestParameters.username, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UserApiUserEndpointGetSessionStatsUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointGetSessionStatsUser(requestParameters = {}, options) {
            return localVarFp.userEndpointGetSessionStatsUser(requestParameters.from, requestParameters.to, requestParameters.username, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UserApiUserEndpointGetUserInfoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointGetUserInfo(requestParameters, options) {
            return localVarFp.userEndpointGetUserInfo(requestParameters.username, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UserApiUserEndpointGetUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointGetUsers(requestParameters = {}, options) {
            return localVarFp.userEndpointGetUsers(requestParameters.hasPermission, requestParameters.hasRole, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UserApiUserEndpointIsPermittedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointIsPermitted(requestParameters = {}, options) {
            return localVarFp.userEndpointIsPermitted(requestParameters.permission, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UserApiUserEndpointLoginGoogleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointLoginGoogle(requestParameters, options) {
            return localVarFp.userEndpointLoginGoogle(requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UserApiUserEndpointRegisterUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointRegisterUser(requestParameters, options) {
            return localVarFp.userEndpointRegisterUser(requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UserApiUserEndpointRegisterUserGoogleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointRegisterUserGoogle(requestParameters, options) {
            return localVarFp.userEndpointRegisterUserGoogle(requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UserApiUserEndpointRequestResetPasswordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointRequestResetPassword(requestParameters, options) {
            return localVarFp.userEndpointRequestResetPassword(requestParameters.body, requestParameters.from, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UserApiUserEndpointResetPasswordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointResetPassword(requestParameters, options) {
            return localVarFp.userEndpointResetPassword(requestParameters.resetPasswordWithTokenDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointRolesAndPermissions(options) {
            return localVarFp.userEndpointRolesAndPermissions(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointUserInfo(options) {
            return localVarFp.userEndpointUserInfo(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UserApiUserEndpointUserStatisticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEndpointUserStatistics(requestParameters = {}, options) {
            return localVarFp.userEndpointUserStatistics(requestParameters.from, requestParameters.to, options).then((request) => request(axios, basePath));
        },
    };
};
exports.UserApiFactory = UserApiFactory;
/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
class UserApi extends base_1.BaseAPI {
    /**
     *
     * @param {UserApiUserEndpointActivateEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    userEndpointActivateEmail(requestParameters, options) {
        return (0, exports.UserApiFp)(this.configuration).userEndpointActivateEmail(requestParameters.token, requestParameters.redirect, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UserApiUserEndpointChangeEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    userEndpointChangeEmail(requestParameters, options) {
        return (0, exports.UserApiFp)(this.configuration).userEndpointChangeEmail(requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UserApiUserEndpointChangePasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    userEndpointChangePassword(requestParameters, options) {
        return (0, exports.UserApiFp)(this.configuration).userEndpointChangePassword(requestParameters.changePasswordDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    userEndpointCheckAuth(options) {
        return (0, exports.UserApiFp)(this.configuration).userEndpointCheckAuth(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UserApiUserEndpointDoInitialSetupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    userEndpointDoInitialSetup(requestParameters = {}, options) {
        return (0, exports.UserApiFp)(this.configuration).userEndpointDoInitialSetup(requestParameters.initialSetupRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UserApiUserEndpointDoesEmailExistRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    userEndpointDoesEmailExist(requestParameters, options) {
        return (0, exports.UserApiFp)(this.configuration).userEndpointDoesEmailExist(requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UserApiUserEndpointDoesGoogleUserExistRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    userEndpointDoesGoogleUserExist(requestParameters, options) {
        return (0, exports.UserApiFp)(this.configuration).userEndpointDoesGoogleUserExist(requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UserApiUserEndpointDoesUsernameExistRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    userEndpointDoesUsernameExist(requestParameters, options) {
        return (0, exports.UserApiFp)(this.configuration).userEndpointDoesUsernameExist(requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UserApiUserEndpointGetCurrentKeycloakUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    userEndpointGetCurrentKeycloakUsers(requestParameters = {}, options) {
        return (0, exports.UserApiFp)(this.configuration).userEndpointGetCurrentKeycloakUsers(requestParameters.createUsers, requestParameters.xKeycloakUserlessToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UserApiUserEndpointGetExternalUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    userEndpointGetExternalUsers(requestParameters, options) {
        return (0, exports.UserApiFp)(this.configuration).userEndpointGetExternalUsers(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UserApiUserEndpointGetSessionStatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    userEndpointGetSessionStats(requestParameters = {}, options) {
        return (0, exports.UserApiFp)(this.configuration).userEndpointGetSessionStats(requestParameters.companyReference, requestParameters.from, requestParameters.jobTitle, requestParameters.to, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UserApiUserEndpointGetSessionStatsExtUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    userEndpointGetSessionStatsExtUser(requestParameters = {}, options) {
        return (0, exports.UserApiFp)(this.configuration).userEndpointGetSessionStatsExtUser(requestParameters.from, requestParameters.to, requestParameters.username, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UserApiUserEndpointGetSessionStatsUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    userEndpointGetSessionStatsUser(requestParameters = {}, options) {
        return (0, exports.UserApiFp)(this.configuration).userEndpointGetSessionStatsUser(requestParameters.from, requestParameters.to, requestParameters.username, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UserApiUserEndpointGetUserInfoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    userEndpointGetUserInfo(requestParameters, options) {
        return (0, exports.UserApiFp)(this.configuration).userEndpointGetUserInfo(requestParameters.username, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UserApiUserEndpointGetUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    userEndpointGetUsers(requestParameters = {}, options) {
        return (0, exports.UserApiFp)(this.configuration).userEndpointGetUsers(requestParameters.hasPermission, requestParameters.hasRole, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UserApiUserEndpointIsPermittedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    userEndpointIsPermitted(requestParameters = {}, options) {
        return (0, exports.UserApiFp)(this.configuration).userEndpointIsPermitted(requestParameters.permission, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UserApiUserEndpointLoginGoogleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    userEndpointLoginGoogle(requestParameters, options) {
        return (0, exports.UserApiFp)(this.configuration).userEndpointLoginGoogle(requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UserApiUserEndpointRegisterUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    userEndpointRegisterUser(requestParameters, options) {
        return (0, exports.UserApiFp)(this.configuration).userEndpointRegisterUser(requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UserApiUserEndpointRegisterUserGoogleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    userEndpointRegisterUserGoogle(requestParameters, options) {
        return (0, exports.UserApiFp)(this.configuration).userEndpointRegisterUserGoogle(requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UserApiUserEndpointRequestResetPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    userEndpointRequestResetPassword(requestParameters, options) {
        return (0, exports.UserApiFp)(this.configuration).userEndpointRequestResetPassword(requestParameters.body, requestParameters.from, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UserApiUserEndpointResetPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    userEndpointResetPassword(requestParameters, options) {
        return (0, exports.UserApiFp)(this.configuration).userEndpointResetPassword(requestParameters.resetPasswordWithTokenDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    userEndpointRolesAndPermissions(options) {
        return (0, exports.UserApiFp)(this.configuration).userEndpointRolesAndPermissions(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    userEndpointUserInfo(options) {
        return (0, exports.UserApiFp)(this.configuration).userEndpointUserInfo(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UserApiUserEndpointUserStatisticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    userEndpointUserStatistics(requestParameters = {}, options) {
        return (0, exports.UserApiFp)(this.configuration).userEndpointUserStatistics(requestParameters.from, requestParameters.to, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.UserApi = UserApi;
//# sourceMappingURL=user-api.js.map